import { gql } from '@lcs/shared/api';

export const deleteRoleMutation = gql`
   mutation DeleteRole($roleId: UInt!) {
      deleteRole(id: $roleId)
   }
`;
